/*!

=========================================================
* Black SalesDashboard React v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import GoogleSSO from "components/GoogleSSO/GoogleSSO";
import MicrosoftSSO from "components/MicrosoftSSO/MicrosoftSSO";
// core components


import routes from "routes.js";

import logo from "assets/img/logo.svg";
import {authenticationService} from "../../services";

var ps;

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            backgroundColor: "blue",
        };
    }

    componentDidMount() {
        authenticationService.currentUser.subscribe(x => {
            this.setState({currentUser: x})
        });
    }

    getRoutes = routes => {
        return routes.map((prop, key) => {
            if (prop.layout === "/login") {
                return (
                    <Route
                        path={prop.layout + prop.path}
                        component={prop.component}
                        key={key}
                    />
                );
            } else {
                return null;
            }
        });
    };

    render() {
        if (authenticationService.currentUserValue) {
            return (
                <Redirect from={"*"} to={"/admin/sales-dashboard"} />
            )
        }
        return (
            <>
                <div className="wrapper">

                    <div
                        className="main-panel login-panel"
                        ref="mainPanel"
                        data={this.state.backgroundColor}
                    >
                        <Switch>
                            {this.getRoutes(routes)}
                            <Redirect from="*" to="/login"/>
                        </Switch>

                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                            <GoogleSSO/>
                            {process.env.REACT_APP_MICROSOFT_CLIENT_ID && <MicrosoftSSO/>}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Login;
